import * as yup from "yup";

export const schema = yup.object({
    username: yup.string().required("Username tidak boleh kosong"),
    password: yup.string().required("Password tidak boleh kosong"),
}).required();
